import { ErrorWithContext } from "../error-with-context";

const ARTICLE_RATING_LOCAL_STORAGE_KEY = 'prk-article-rating';

/**
 * @return {{[key: number|string]: number}}
 */
const getUserRatedArticles = () => {
    try {
        if (typeof localStorage !== 'undefined') {
            return localStorage.getItem(ARTICLE_RATING_LOCAL_STORAGE_KEY)
                ? JSON.parse(localStorage.getItem(ARTICLE_RATING_LOCAL_STORAGE_KEY))
                : {};
        }
    } catch (e) {
    }

    return {};
}

/**
 * @param {number} articleId
 * @return {number|null}
 */
export const getUserArticleRating = (articleId) => {
    try {
        if (typeof localStorage !== 'undefined') {
            const rates = localStorage.getItem(ARTICLE_RATING_LOCAL_STORAGE_KEY)
                ? JSON.parse(localStorage.getItem(ARTICLE_RATING_LOCAL_STORAGE_KEY))
                : {};

            return rates[articleId] ?? null;
        }
    } catch (e) {
    }

    return null;
}

/**
 * @param {number} articleId
 * @param {number} rating
 * @return {Promise<void>}
 */
export const saveUserArticleRating = (articleId, rating) => {
    try {
        const rates = getUserRatedArticles();
        rates[articleId] = rating;
        if (typeof localStorage !== 'undefined') {
            localStorage.setItem(ARTICLE_RATING_LOCAL_STORAGE_KEY, JSON.stringify(rates));
        }
    } catch (e) {
        return Promise.reject(new ErrorWithContext('Failed saving article rating', {
            extra: { articleId, rating }
        }));
    }

    return fetch('/api/prk/blog/article/rating/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ articleId, rating }),
    });
}